import { orderBy } from 'lodash';
import { DossierId } from '@/dossier/models/AbstractDossier';
import AbstractContext from '@/shared/models/AbstractContext';
import { mergeInto, removeBy } from '@/shared/utils';
import EntityType from '../constants/EntityType';
import SubEntityType from '../constants/SubEntityType';
import MediaFile2, { MediaFileId2 } from './MediaFile2';
import MediaTargetData from '@/general/models/MediaTargetData';
import { ModelID } from '@/shared/models/BaseModel';

export default class MediaContext2 extends AbstractContext {
  constructor(readonly dossierId: DossierId, readonly list: Array<MediaFile2>) {
    super();
    this.sortList();
  }

  getFilteredList(targetData: MediaTargetData): Array<MediaFile2> {
    switch (targetData.entityType) {
      case EntityType.DOSSIER:
        return this.list;
      case EntityType.WHEELS:
        if (targetData.subEntityType === SubEntityType.TIRE) {
          return this.getFilesBySubEntityType(SubEntityType.TIRE, targetData.subEntityId);
        } else return this.getFilesByEntityData(EntityType.WHEELS, targetData.entityId, SubEntityType.BRAKE, null);
      case EntityType.JOB:
        if (targetData.subEntityType === SubEntityType.DIAGNOSTIC) {
          return this.getFilesBySubEntityType(SubEntityType.DIAGNOSTIC, targetData.subEntityId);
        } else return this.getFilesByEntityType(EntityType.JOB, targetData.entityId);
      case EntityType.DRIVE_BOOKING:
        return this.getFilesByEntityType(EntityType.DRIVE_BOOKING, targetData.entityId);
      default:
        console.error('Unknown media entity type:', targetData.entityType);
        return [];
    }
  }

  sortList(): void {
    this.list.splice(0, this.list.length, ...orderBy(this.list, 'createdOn', 'desc'));
  }

  getAllMedia(): Array<MediaFile2> {
    return this.list;
  }

  getFilesByEntityData(entityType?: EntityType, entityId?: ModelID | null, subEntityType?: SubEntityType, subEntityId?: ModelID | null): Array<MediaFile2> {
    return this.list.filter(file => file.entityType === entityType && file.entityId === entityId && file.subEntityType === subEntityType && file.subEntityId === subEntityId);
  }

  getFilesByEntityType(entityType: EntityType, entityId?: ModelID | null): Array<MediaFile2> {
    return this.list.filter(file => file.entityType === entityType && file.entityId === entityId);
  }

  getFilesBySubEntityType(subEntityType: SubEntityType, subEntityId?: ModelID | null): Array<MediaFile2> {
    return this.list.filter(file => file.subEntityType === subEntityType && file.subEntityId === subEntityId);
  }

  updateList(...files: Array<MediaFile2>): void {
    files.forEach(file => mergeInto(file, this.list, f => file.content.original === f.content.original));
    this.sortList();
  }

  removeFile(id: MediaFileId2): void {
    removeBy(this.list, f => f.id === id);
  }
}